export default {
    measurement:{
        measurement_one:0,
        measurement_one_display:0,
    
        measurement_two:0,
        measurement_two_display:0,
    
        measurement_three:0,
        measurement_three_display:0,
    
        measurement_four:0,
        measurement_four_display:0,
    
        measurement_five:0,
        measurement_five_display:0,
    
        measurement_six:0,
        measurement_six_display:0,
    
        measurement_seven:0,
        measurement_seven_display:0,
    },
    coils:{},
    countries:'',
    states:'',
}